// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Inter-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Inter-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Inter-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Inter-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Inter-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Inter-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Inter-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("Inter-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("Inter-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("Inter-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("Inter-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

/* @font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 100;
  src: url("Inter-Thin.woff2") format("woff2"),
       url("Inter-Thin.woff") format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 100;
  src: url("Inter-ThinItalic.woff2") format("woff2"),
       url("Inter-ThinItalic.woff") format("woff");
} */

/* @font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 200;
  src: url("Inter-ExtraLight.woff2") format("woff2"),
       url("Inter-ExtraLight.woff") format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 200;
  src: url("Inter-ExtraLightItalic.woff2") format("woff2"),
       url("Inter-ExtraLightItalic.woff") format("woff");
} */

/* @font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 300;
  src: url("Inter-Light.woff2") format("woff2"),
       url("Inter-Light.woff") format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 300;
  src: url("Inter-LightItalic.woff2") format("woff2"),
       url("Inter-LightItalic.woff") format("woff");
} */

@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}

@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}

@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
}
/* 
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 800;
  src: url("Inter-ExtraBold.woff2") format("woff2"),
       url("Inter-ExtraBold.woff") format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 800;
  src: url("Inter-ExtraBoldItalic.woff2") format("woff2"),
       url("Inter-ExtraBoldItalic.woff") format("woff");
}

@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 900;
  src: url("Inter-Black.woff2") format("woff2"),
       url("Inter-Black.woff") format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  italic;
  font-weight: 900;
  src: url("Inter-BlackItalic.woff2") format("woff2"),
       url("Inter-BlackItalic.woff") format("woff");
} */`, "",{"version":3,"sources":["webpack://./../ui/src/assets/fonts/inter/inter.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;;;;;;;;;;;;GAaG;;AAEH;;;;;;;;;;;;;GAaG;;AAEH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;6DAC6C;AAC/C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;6DAC4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;6DAC4C;AAC9C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;6DACkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;6DAC8C;AAChD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;8DACoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;8DAC0C;AAC5C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;8DACgD;AAClD;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG","sourcesContent":[":root {\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-text-size-adjust: 100%;\n}\n\n/* @font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 100;\n  src: url(\"Inter-Thin.woff2\") format(\"woff2\"),\n       url(\"Inter-Thin.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 100;\n  src: url(\"Inter-ThinItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-ThinItalic.woff\") format(\"woff\");\n} */\n\n/* @font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 200;\n  src: url(\"Inter-ExtraLight.woff2\") format(\"woff2\"),\n       url(\"Inter-ExtraLight.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 200;\n  src: url(\"Inter-ExtraLightItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-ExtraLightItalic.woff\") format(\"woff\");\n} */\n\n/* @font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 300;\n  src: url(\"Inter-Light.woff2\") format(\"woff2\"),\n       url(\"Inter-Light.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 300;\n  src: url(\"Inter-LightItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-LightItalic.woff\") format(\"woff\");\n} */\n\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 400;\n  src: url(\"Inter-Regular.woff2\") format(\"woff2\"),\n       url(\"Inter-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 400;\n  src: url(\"Inter-Italic.woff2\") format(\"woff2\"),\n       url(\"Inter-Italic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 500;\n  src: url(\"Inter-Medium.woff2\") format(\"woff2\"),\n       url(\"Inter-Medium.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 500;\n  src: url(\"Inter-MediumItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-MediumItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 600;\n  src: url(\"Inter-SemiBold.woff2\") format(\"woff2\"),\n       url(\"Inter-SemiBold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 600;\n  src: url(\"Inter-SemiBoldItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-SemiBoldItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 700;\n  src: url(\"Inter-Bold.woff2\") format(\"woff2\"),\n       url(\"Inter-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 700;\n  src: url(\"Inter-BoldItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-BoldItalic.woff\") format(\"woff\");\n}\n/* \n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 800;\n  src: url(\"Inter-ExtraBold.woff2\") format(\"woff2\"),\n       url(\"Inter-ExtraBold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 800;\n  src: url(\"Inter-ExtraBoldItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-ExtraBoldItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 900;\n  src: url(\"Inter-Black.woff2\") format(\"woff2\"),\n       url(\"Inter-Black.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  italic;\n  font-weight: 900;\n  src: url(\"Inter-BlackItalic.woff2\") format(\"woff2\"),\n       url(\"Inter-BlackItalic.woff\") format(\"woff\");\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
